import styled from "styled-components";
import SelectAirport from "../../custom/SelectAirport";
import useAirportCodes from "../../../customHooks/useAirportCodes";
import { useRef, useState } from "react";
import apiClient from "../../../apiClient";
import useSWR from "swr";
import VirtualTable from "../../custom/VirtualTable";
import ActionIcon from "../../custom/ActionIcon";
import { extractReactTableData, fileDownload, SchemaType } from "../../../utils";
import moment from "moment";

const fetcher = async (key: string) => {
    try {
        const res = await apiClient.get(key);
        return res.data;
    } catch (err) {
        return [];
        alert(err);
    }
}

export default function DataPull() {

    const { airportCodes, airportCodesMap } = useAirportCodes();
    const [s_pou, set_s_pou] = useState('');
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1; // getMonth is zero-indexed, so add 1
    const formattedMonth = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
    const [month, setMonth] = useState(`${currentYear}-${formattedMonth}`);
    const monthNumber = parseInt(month.split('-')[1], 10); 
    const runQuery = Boolean(s_pou) && s_pou.length === 3 && Boolean(month); 
    const {
        data
    } = useSWR(runQuery && `/transfers-analytics?s_pol=EWR&s_pou=${s_pou}&month=${monthNumber}&year=${currentYear}`, 
        fetcher,
        {
            fallbackData: []
        }
    );

    const tableRef = useRef();

    const downloadData = () => {
        const schema: Array<SchemaType> = [{
            key: 't_created', 
            name: 'Received',
            datetime: true
        }, {
            key: 's_uld',
            name: 'ULD'
        }, {
            key: 's_mawb',
            name: 'AWB',
            mawb: true
        }, {
            key: 's_flight_id',
            name: 'Flight'
        }, {
            key: 's_origin',
            name: 'Origin'
        }, {
            key: 's_pol',
            name: 'POL'
        }, {
            key: 's_pou',
            name: 'POU'
        }, {
            key: 's_destination',
            name: 'Dest.'
        }, {
            key: 'f_weight',
            name: 'Weight'
        }, {
            key: 's_pieces_type',
            name: 'Type'
        }, {
            key: 'i_actual_piece_count',
            name: 'Actual PCS'
        }, {
            key: 'i_pieces_total',
            name: 'Total PCS'
        }, {
            key: 's_commodity',
            name: 'Commodity'
        }];

        const data = extractReactTableData(tableRef, [], schema);
        fileDownload(data, `Transfers Analytics ${moment().format('YYYY-MM-DD HH-mm')}.csv`)
    }

    return (
        <div>
            <SpaceBetweenContainer>
                <FlexContainer>
                    <h4>Download data from POL = EWR to POU =</h4>
                    <SelectAirport
                        airports={airportCodes}
                        airportCodesMap={airportCodesMap}
                        code={s_pou}
                        setCode={set_s_pou}
                    />
                </FlexContainer>
                <ActionIcon 
                    type={'download'}
                    onClick={downloadData}
                />
            </SpaceBetweenContainer>
            <FlexContainer>
                <h4 className="mr-3">Pick Month</h4>
                <input
                    type="month"
                    id="monthPicker"
                    value={month}
                    min={`${currentYear}-01`}
                    max={`${currentYear}-${formattedMonth}`}
                    onChange={(e) => setMonth(e.target.value)}
                />
            </FlexContainer>
            <VirtualTable 
                data={data || []}
                mapping={[{
                    name: 'Received',
                    value: 't_created',
                    datetime: true,
                    utc: true
                }, {
                    name: 'ULD',
                    value: 's_uld'
                }, {
                    name: 'AWB',
                    value: 's_mawb',
                    s_mawb: true
                }, {
                    name: 'Flight',
                    value: 's_flight_id'
                }, {
                    name: 'Origin',
                    value: 's_origin'
                }, {
                    name: 'POL',
                    value: 's_pol'
                }, {
                    name: 'POU',
                    value: 's_pou'
                }, {
                    name: 'Dest.',
                    value: 's_destination'
                }, {
                    name: 'Weight',
                    value: 'f_weight'
                }, {
                    name: 'Actual PCS',
                    value: 'i_actual_piece_count',
                    number: true
                }, {
                    name: 'Total PCS',
                    value: 'i_pieces_total',
                    number: true
                }, {
                    name: 'Commodity',
                    value: 's_commodity'
                }]}
                numRows={15}
                reactTableRef={tableRef}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    align-items: baseline;
`;

const SpaceBetweenContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;